export const categoryPercentageSettings = {
  title: 'Tickets by Category',
  color1: '#008567',
  color2: '#6666CC',
  color3: '#EB0000',
  color4: '#CCA300',
  color5: '#CC0066',
  color6: '#8AFFE5',
  color7: '#3d3db8',
  color8: '#b3b3e6',
  color9: '#806600',
  color10: '#444653',
  type1: 'pie',
  marginBottom: 100,
  y: 20
};
export const debtAnalysisSettings = {
  title: 'Category Percentage',
  color1: '#008567',
  color2: '#6666CC',
  color3: '#EB0000',
  color4: '#CCA300',
  color5: '#CC0066',
  color6: '#8AFFE5',
  color7: '#3d3db8',
  color8: '#b3b3e6',
  color9: '#806600',
  color10: '#444653',
  type1: 'pie',
};
export const ticketGenerationSourceSettings = {
  title: 'Ticket Generation Source',
  color1: '#008567',
  color2: '#6666CC',
  color3: '#EB0000',
  color4: '#CCA300',
  color5: '#CC0066',
  color6: '#ABFFEC',
  color7: '#3d3db8',
  color8: '#b3b3e6',
  color9: '#806600',
  color10: '#444653',
  type1: 'pie',
  y: 20

};

export const humanSouceSettings = {
  title: 'Human Vs Auto-Ticket Source',
  color1: '#008567',
  color2: '#66C',
  type1: 'pie',
  y: 20

};
export const avgResolveTimeVsPrioritySettings = {
  title: 'Average Resolution Time - Priority',
  color1: '#008567',
  // color2: '#B38F00',
  type1: 'column',
  // type2: 'column',
  name1: 'Resolved (min)',
  // name2: 'Response (min)',
  y: 10,
  showLegend: true,
  labels: true,
  type: 'datetime',
  hour: '%H:%M',
  tooltip: {
    pointFormatter: function () {
      const minutes: number = (this as any).y;

      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;
        return `${days.toFixed(0)} days ${hours.toFixed(0)} hours ${remainingSeconds.toFixed(0)} minutes`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)} hours ${remainingMinutes.toFixed(0)} minutes`;
      } else {
        return `${minutes.toFixed(0)} minutes`;
      }
    },
  },
  pointWidth:50,
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '8px',
    },
    formatter: function () {
      const minutes: number = (this as any).y;
      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;

        return `${days.toFixed(0)}d ${hours.toFixed(0)}h ${remainingSeconds.toFixed(0)}m`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)}h ${remainingMinutes.toFixed(0)}m`;
      } else {
        return `${minutes.toFixed(0)}m`;
      }
    }
  }
};

export const avgResolveTimeVsSeveritySettings = {
  title: 'Average Response/Resolution Time',
  color1: '#008567',
  color2: '#B38F00',
  type1: 'column',
  type2: 'column',
  name1: 'Resolved (min)',
  name2: 'Response (min)',
  showLegend: true,
  y: 10,
  labels: true,
  type: 'datetime',
  hour: '%H:%M',
  tooltip: {
    pointFormatter: function () {
      const minutes: number = (this as any).y;

      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;
        return `${days.toFixed(0)} days ${hours.toFixed(0)} hours ${remainingSeconds.toFixed(0)} minutes`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)} hours ${remainingMinutes.toFixed(0)} minutes`;
      } else {
        return `${minutes.toFixed(0)} minutes`;
      }
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '8px',
    },
    formatter: function () {
      const minutes: number = (this as any).y;
      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;

        return `${days.toFixed(0)}d ${hours.toFixed(0)}h ${remainingSeconds.toFixed(0)}m`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)}h ${remainingMinutes.toFixed(0)}m`;
      } else {
        return `${minutes.toFixed(0)}m`;
      }
    }
  }
};

export const getAssigmentGroupDistributionSettings = {
  title: 'Assignment Group Distribution (Top 10)',
  color1: '#66C',
  type1: 'column',
  yAxisTickInterval: 2000,
  name1: 'Tickets',
  y: 20,
  dataLabels: {
    enabled: true,
  }
};
export const avgResolvedTimeVsAssignmentGroupSettings = {
  title: 'Highest Average Resolution Time - Assignment Group',
  color1: '#6666CC',
  type1: 'column',
  name1: ' Assignment Group (Top 10)',
  y: 20,
  showLegend: true,
  labels: true,
  type: 'datetime',
  hour: '%H:%M',
  dataLabelColor: '#000212',
  tooltip: {
    pointFormatter: function () {
      const minutes: number = (this as any).y;

      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;
        return `${days.toFixed(0)} days ${hours.toFixed(0)} hours ${remainingSeconds.toFixed(0)} minutes`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)} hours ${remainingMinutes.toFixed(0)} minutes`;
      } else {
        return `${minutes.toFixed(0)} minutes`;
      }
    },
  },
  pointWidth:50,
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '8px',
    },
    formatter: function () {
      const minutes: number = (this as any).y;
      if (minutes >= 1440) {
        const days: number = Math.floor(minutes / 1440);
        const remainingMinutes: number = minutes % 1440;
        const hours: number = Math.floor(remainingMinutes / 60);
        const remainingSeconds: number = remainingMinutes % 60;

        return `${days.toFixed(0)}d ${hours.toFixed(0)}h ${remainingSeconds.toFixed(0)}m`;
      } else if (minutes >= 60) {
        const hours: number = Math.floor(minutes / 60);
        const remainingMinutes: number = minutes % 60;
        return `${hours.toFixed(0)}h ${remainingMinutes.toFixed(0)}m`;
      } else {
        return `${minutes.toFixed(0)}m`;
      }
    }
  }
};
export const getMostCommonIssuesSettings = {
  title: 'Most Common Issues (Top 5)',
  color1: '#CC0066',
  color2: '#66C',
  type1: 'column',
  name1: 'Issues',
  y: 20,
  yAxisTickInterval:0,
  pointWidth:50,
  dataLabels: {
    enabled: true,
  }
};

export const getTicketPerHourSettings = {
  title: 'Tickets During Each Hour of Day',
  color1: '#CC0066',
  color2: '#66C',
  type1: 'line',
  name1: 'Tickets',
  xAxisTickInterval: 0,
  yAxisTickInterval: 0,
  y: 20

};

export const getTicketPerWeekSettings = {
  title: 'Tickets During Each Day of the Week',
  color1: '#6666CC',
  color2: '#66C',
  type1: 'line',
  name1: 'Tickets',
  xAxisTickInterval: 10,
  yAxisTickInterval: 10,
  y: 20

};

export const getComplexityAgentsSettings = {
  title: 'Complexity/Ticket Volume for Agents',
  color1: '#C06',
  color2: '#66C',
  name1: 'Ticket Volume',
  type1: 'line',
  type2: 'line',
  name2: 'Complexity',
  xAxisTickInterval: 10,
  yAxisTickInterval: 300,
  showLegend: true,
  yaxisTitle: 'Ticket Volume',
  y1axisTitle: 'Complexity',
  yAxis: 1,
  y: 20

};

export const getTicketPerDaySettings = {
  title: 'Tickets for Each Day',
  color1: '#CC0066',
  color2: '#66C',
  type1: 'line',
  name1: 'Tickets',
  xAxisTickInterval: 10,
  yAxisTickInterval: 2500,
  y: 20

};
export const volumeForecastingSetting = {
  title: 'Complexity/Ticket Volume for Agents',
  color1: '#008567',
  color2: '#444653',
  type1: 'line',
  name1: 'Actual',
  name2: 'Forecasting',
  type2: 'line',
  xAxisTickInterval: 10,
  yAxisTickInterval: 250,
  yaxisTitle: 'Ticket Volume',
};

export const humanAutoresolveSettings = {
  title: 'Maturity Assessment -Human Vs Auto-Resolved Tickets',
  color1: '#CCA300',
  color2: '#F20079',
  type1: 'pie',
  y: 20,
};

export const managementSourceSetting = {
  title: 'Monitoring Source',
  color1: '#CCA300',
  color2: '#F20079',
  color3: '#008567',
  color4: '#6666CC',
  color5: '#CC0066',
  color6: '#8AFFE5',
  color7: '#3d3db8',
  color8: '#b3b3e6',
  color9: '#806600',
  color10: '#444653',
  type1: 'pie',
  y: 20,
};